import Help from 'features/help/screens/Help';
import React from 'react';

export default function HelpPage() {
  return <Help />;
}
